import Skeleton from 'react-loading-skeleton';
import React, { useMemo } from 'react';
import { CheckboxTableHeaderProps } from '@dev/ee-components';

import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';

import { useHeadersOfContactsListTable } from './useHeadersOfContactsList';

export const useSkeletonRows = () => {
    const headers: CheckboxTableHeaderProps[] = useHeadersOfContactsListTable();

    const singleSkeletonRow = useMemo(
        () =>
            headers.reduce(
                (acc, singleHeader) => ({
                    ...acc,
                    [singleHeader?.id]: <Skeleton />,
                }),
                {}
            ),
        []
    );

    return [...Array(DEFAULT_PER_PAGE_COUNT)].fill(singleSkeletonRow);
};
